import React from 'react';
import { baseURL } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { Avatar } from '@mui/material';
import { useCommonInits } from 'hooks/useCommonInits';
import { ROUTE_PATHS } from 'app/utils/route';
export const AppLogo = () => {
    const logoURL = require('assets/images/ioagpl.png');
    const defaultLogo = require('assets/images/ioagpl.png');
    const navigateTo = (path, params = {}) => {
        navigate(path, params);
    };
    const { navigate } = useCommonInits();

    return (
        <Avatar sx={styles.avatar}>
            <img
                alt="logo"
                width="100%"
                src={logoURL}
                style={styles.logo}
                onClick={() => navigateTo(`/${ROUTE_PATHS.apcmDashboard}`)}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = defaultLogo;
                    currentTarget.style = '';
                }}
            />
        </Avatar>
    );
};

const styles = {
    avatar: {
        bgcolor: 'transparent',
        width: '100px',
        height: '100px',
        borderRadius: 'unset',
        marginBottom: 2,
    },
    logo: {
        width: '80%',
        // height:'80%',
        // marginTop:'6px',
        marginRight: '15px',
        borderRadius: '4px',
        backgroundColor: 'white',
    },
};
